export default "__VITE_ASSET__NseweAKA__"